<template>
  <div class="mt-4 mb-5">
    <!-- Basic Details - Start -->
    <div class="row">
      <div class="col-12 pr-5 pl-5 mt-4">
        <div class="row">
          <div class="col-md-6">
            <span class="mr-3 align-middle col-mb heading-text">
               <i class="fa fa-ban mr-2"/> Block any IP or IP-Range
            </span>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-6">
            <h3>Blocked IP's List</h3>
          </div>
          <div class="col-md-6">
            <button class="btn btn-primary pull-right" @click="openBlockIpModal">Block New IP</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12" >
            <div v-if="blockIpsList.length <= 0">
              <span class="text-danger ">
                No Blocked IPs to show here...
              </span>
            </div>
            <div v-else class="table-responsive">
              <table class="table table-striped ">
                <thead class="text-primary">
                <tr>
                  <th>IPs</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(ip, index) in blockIpsList" :key="index">
                  <td><small><b>{{ip}}</b></small></td>
                  <td>
                    <div v-if="loading===ip" class="loader" style="width: 20px;height: 20px; margin: 0 0 !important;"></div>
                    <span v-else><span class="btn btn-sm btn-danger" v-on:click="unBlockIp(ip)">Unblock</span></span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <block-ips-modal ref="blockIpsModal" />
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import blockIpsModal from "./blockIpsModal";
import _ from "lodash";
export default {
name: "BlockIps",
  props: {
    account: {
      type: Object,
      required: true
    },
    fromCollaborator: {
      type: Boolean,
      required: false
    },
    supervisor: {
      type: Object,
      required: false
    }
  },
  components: {
    blockIpsModal
  },
  data () {
    return {
      blockIpsList: [],
      loading: false
    }
  },
  computed: {
    uid () {
      return (this.fromCollaborator) ? this.supervisor.supervisorId : this.$store.getters.user.uid;
    },
    accounts () {
      return this.$store.getters["hosting/accounts"]
    },
  },
  watch: {
    account () {
      this.fetchData();
    }
  },
  mounted () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      this.blockIpsList = (this.accounts.length > 0 && this.account) ? this.accounts[this.account.planIndex].primary.blockIpsList || []  : [];
    },
    openBlockIpModal () {
      this.$refs.blockIpsModal.load()
    },
    async unBlockIp (ip) {
      try {
        this.loading = ip
        await this.$http.post('security/unblock-ip', {
          ip: this.account.ftp.host,
          blockIp: ip,
          grant_type: "token",
        });
        this.blockIpsList.splice(this.blockIpsList.indexOf(ip), 1)
        const accountRef = await db.collection('hostingAccounts').doc(this.uid).get();
        const { accounts } = accountRef.data();
        const beforePayload = JSON.parse(JSON.stringify(accounts))
        const cAccount = accounts[this.account.planIndex];
        let accountObject = cAccount.primary
        accountObject.blockIpsList = this.blockIpsList
        await this.addHostingAccountEventLog({hostingAccountId : this.uid ,  afterPayload: accounts , beforePayload : beforePayload, action: 'UnBlock IP'})
        await db.collection('hostingAccounts').doc(this.uid).update({
          accounts
        });
        swal({
          title: "Success!",
          text: `Successfully unblocked this IP: ${ip}`,
          type: "success",
        });
      } catch (e) {
        console.log(e.toString());
        swal({
          title: "Something went wrong!",
          text: `Error in unblocking the IP: ${ip}`,
          type: "error",
        });
      }
      this.loading = null
    },
    async blockIp (ip) {
      try {
        const ipExist = this.blockIpsList.includes(ip);
        console.log(ipExist)
        if (ipExist) {
          return swal({
            title: "Error!",
            text: 'This IP is already blocked.',
            type: "error",
          });
        }
        await this.$http.post('security/block-ip', {
          ip: this.account.ftp.host,
          blockIp: ip,
          grant_type: "token",
        });
        this.blockIpsList.push(ip)
        const accountRef = await db.collection('hostingAccounts').doc(this.uid).get();
        const { accounts } = accountRef.data();
        const beforePayload = JSON.parse(JSON.stringify(accounts))
        const cAccount = accounts[this.account.planIndex];
        let accountObject = cAccount.primary;
        accountObject.blockIpsList = this.blockIpsList
        await this.addHostingAccountEventLog({hostingAccountId : this.uid ,  afterPayload: accounts , beforePayload : beforePayload, action: 'Block IP'})
        await db.collection('hostingAccounts').doc(this.uid).update({
          accounts
        });
        swal({
          title: "Success!",
          text: `Successfully block this IP: ${ip}.`,
          type: "success",
        });
      } catch (e) {
        console.log(e.toString());
        swal({
          title: "Something went wrong!",
          text: `Error in blocking this IP`,
          type: "error",
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
